<h2 mat-dialog-title>{{ editMode ? 'Edit Quick Build' : 'Create Quick Build' }}</h2>

<mat-dialog-content class="tw-pt-4 tw-pb-0">
  <form [formGroup]="form" class="tw-space-y-4">
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Category (Optional)</mat-label>
      <input
        matInput
        formControlName="category"
        placeholder="e.g., Engineering, Sales, Marketing" />
      <mat-hint>Group related quick builds together</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Description (Optional)</mat-label>
      <textarea
        matInput
        formControlName="description"
        rows="3"
        placeholder="Brief description of this quick build"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close()">Cancel</button>
  <button mat-raised-button [disabled]="!form.valid" color="primary" (click)="save()">
    {{ editMode ? 'Save Changes' : 'Create' }}
  </button>
</mat-dialog-actions>
